import {
  maxLengthRule,
  minLengthRule,
  requiredRule,
  useFormControl,
  type FormControlProps,
} from "@mongez/react-form";
import { cn } from "~/shared/lib";
import { ErrorInput } from "./ErrorInput";
import { LabelInput } from "./LabelInput";

export type BaseInputProps = FormControlProps & {
  classes?: {
    wrapper?: string;
    label?: string;
    input?: string;
    error?: string;
  };
};

export function BaseInput({
  className,
  classes,
  rules = [],
  label,
  ...props
}: BaseInputProps) {
  const { id, error, type, name, value, changeValue, otherProps } =
    useFormControl({
      ...props,
      rules: [requiredRule, minLengthRule, maxLengthRule, ...rules],
    });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    changeValue(value);
    props.onChange?.(value);
  };

  return (
    <div
      className={cn("relative flex w-full flex-col gap-2", classes?.wrapper)}
    >
      <LabelInput
        htmlFor={id}
        required={props.required}
        className={cn(classes?.label, error && "text-red-500")}
      >
        {label}
      </LabelInput>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={handleChange}
        {...otherProps}
        className={cn(
          "focus:border-primary-500 focus:ring-primary-default w-full rounded-full border border-black bg-transparent px-6 py-4 text-xs text-black focus:ring-1 focus:outline-none sm:text-sm lg:text-base",
          error && "border-red-500",
          classes?.input,
        )}
      />
      <ErrorInput className={classes?.error}>{error}</ErrorInput>
    </div>
  );
}
